// API error statuses
export const INTERNAL_SERVER_ERROR = 'InternalServerError'
export const VISIT_NOT_FOUND_ERROR = 'VisitNotFound'
export const VISIT_CALL_FORBIDDEN_ERROR = 'VisitCallForbidden'
export const VISIT_COMPLETED_ERROR = 'VisitCompleted'
export const FORBIDDEN_ERROR = 'Forbidden'
export const MESSAGE_NOT_VALID_ERROR = 'MessageNotValid'
export const THIRD_PARTY_ERROR = 'ThirdPartyError'
export const ALLERGY_NAME_NOT_UNIQUE_ERROR = 'AllergyNameNotUnique'
export const ALLERGY_NOT_FOUND_ERROR = 'AllergyNotFound'
export const ALLERGY_NAME_NOT_VALID_ERROR = 'AllergyNameNotValid'
export const ALLERGY_SEVERITY_NOT_VALID_ERROR = 'AllergySeverityNotValid'
export const TREAT_COMMUNICATION_ERROR = 'TreatCommunicationError'
export const CREDENTIALS_NOT_VALID_ERROR = 'CredentialsNotValid'
export const ACCOUNT_NOT_VERIFIED_ERROR = 'AccountNotVerified'
export const ACCOUNT_LOCKED_ERROR = 'AccountLocked'
export const ACCOUNT_NOT_ACTIVE_ERROR = 'AccountNotActive'
export const PERIOD_NOT_VALID_ERROR = 'PeriodNotValid'
export const TYPE_NOT_VALID_ERROR = 'TypeNotValid'
export const SCHEDULE_RECURRING_WEEK_DAYS_NOT_VALID_ERROR = 'ScheduleRecurringWeekDaysNotValid'
export const SCHEDULE_RECURRING_FREQUENCY_NOT_VALID_ERROR = 'ScheduleRecurringFrequencyNotValid'
export const TIME_ZONE_NOT_VALID_ERROR = 'TimeZoneNotValid'
export const SCHEDULE_RECURRING_TYPE_NOT_VALID_ERROR = 'ScheduleRecurringTypeNotValid'
export const OCCURRENCE_NOT_FOUND_ERROR = 'OccurrenceNotFound'
export const PERIOD_OVERLAP_ERROR = 'PeriodOverlap'
export const TOKEN_NOT_VALID_ERROR = 'TokenNotValid'
export const PASSWORD_NOT_VALID_ERROR = 'PasswordNotValid'
export const DUPLICATE_PASSWORD_ERROR = 'DuplicatePassword'

// API methods
export const GET = 'GET'
export const POST = 'POST'
export const PUT = 'PUT'
export const DELETE = 'DELETE'

// API paths
export const API_V1_PATH = 'api/v1'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const makeApiEndpoint = (path) => `${API_V1_PATH}${path}`

export const VISITS_ENDPOINT = makeApiEndpoint('/visits')
export const VIDEO_PATH_SEGMENT = '/video'
export const INPERSON_PATH_SEGMENT = '/inperson'

// Pages paths
export const HOME_PAGE_PATH = '/'
export const CALENDAR_PAGE_PATH = '/calendar'
export const VISITS_PAGE_PATH = '/visits'
export const SERVER_ERROR_PAGE_PATH = '/serverError'
export const WAITING_ROOM_PAGE_PATH = '/waitingroom'
export const ACCOUNT_SETTINGS_PAGE_PATH = '/accountsettings'
export const PATIENTS_CHARTS_PAGE_PATH = '/patientcharts'
export const MEDICATIONS_PAGE_PATH = '/medications'
export const TRACKING_PAGE_PATH = '/tracking'
export const PATIENT_CHART_PAGE_PATH = '/patientcharts/patient'
export const PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH = '/patientcharts/patient/intake-questions'
export const PATIENT_PAST_VISIT_PAGE_PATH = '/patient-past-visit-notes'
export const PATIENT_UPCOMING_VISIT_PAGE_PATH = '/patient-upcoming-visit-notes'
export const VERIFY_EMAIL_PAGE_PATH = '/verifyemail'
export const FORGOT_PASSWORD_PAGE_PATH = '/forgot-password'
export const RESET_PASSWORD_PAGE_PATH = '/resetPassword'
export const ERROR_PAGE_PATH = '/error'
export const SANDBOX_PAGE_PATH = '/sandbox'
export const AUTH_VALIDATE_PAGE_PATH = '/auth/validate'
export const HOME_DELIVERY_GUIDE_PAGE_PATH = '/home-delivery-guide'

// Text
export const START_VISIT_TEXT = 'Start visit'
export const CALENDAR_APPOINTMENT_ALERT_MESSAGE_TEXT =
  'This patient still needs to be seen, although the meeting is not in the availability block.'
export const PAGE_404_TITLE_TEXT = '404 Not Found.'
export const DAILY_TEXT = 'daily'
export const DAYS_TEXT = 'Day(s)'
export const WEEKLY_TEXT = 'weekly'
export const WEEKS_TEXT = 'Week(s)'
export const MONTHLY_TEXT = 'monthly'
export const MONTH_TEXT = 'Month(s)'
export const MALE_ABBREVIATION = 'M'
export const FEMALE_ABBREVIATION = 'F'
export const DOB = 'DOB'
export const MRN = 'MRN'
export const VISIT_DATE_TIME = 'Visit date/time'
export const BOOKING_STATE = 'Booking state'
export const NO_PATIENTS = 'No patients'
export const STATUS = 'Status'
export const CALLING = 'Calling'
export const CALL_ENDED = 'Call ended'
export const NO_ANSWER = 'No answer'
export const PATIENT_MIC_STATUS = 'Patient mic status'
export const PATIENT_CAMERA_STATUS = 'Patient camera status'
export const MUTE_TOGGLE = 'Mute toggle'
export const MIC_ON = 'Mic on'
export const MIC_OFF = 'Mic off'
export const CAMERA_ON = 'Camera on'
export const CAMERA_OFF = 'Camera off'
export const END = 'End'
export const ME = 'Me'
export const PATIENT_IS_UNAVAILABLE = 'Patient is unavailable'
export const TRY_CONNECTING_AGAIN = 'Try connecting again'
export const CALL_HAS_ENDED = 'The call has ended'
export const PHONE_CALL = 'Phone call'
export const VIDEO_CALL = 'Video call'
export const MIC_TOGGLE = 'Microphone toggle'
export const CAMERA_TOGGLE = 'Camera toggle'
export const END_CALL = 'End Call'
export const WAITING_ROOM = 'Waiting room'
export const PROVIDER = 'Provider'
export const PATIENT_WAITING_ROOM_IMG = 'Patient waiting room img'
export const VISIT_TYPE_ICON = 'Visit type icon'
export const VIDEO_VISIT = 'Video visit'
export const PHONE_VISIT = 'Phone visit'
export const IN_PERSON_VISIT = 'In-person visit'
export const ONLINE_VISIT = 'Online visit'
export const DIVIDER = 'Divider'
export const LOGO = 'Logo'
export const SUCCESSFUL = 'Successful'
export const END_VISIT = 'End visit'
export const END_VISIT_BTN_ID = 'endVisitCallBtn'
export const COMPLETE = 'Complete'
export const RESOLVED = 'Resolved'
export const UNRESOLVED = 'Unresolved'
export const ENDED = 'Ended'
export const ASTERISK_TEXT = '*'
export const PLEASE_ENABLE_MICROPHONE_TITLE_TEXT = 'Please enable microphone'
export const PLEASE_ENABLE_MICROPHONE_AND_CAMERA_TITLE_TEXT = 'Please enable video and microphone'
export const PLEASE_INSTALL_MICROPHONE_TITLE_TEXT = 'Please install a microphone'
export const PLEASE_INSTALL_MICROPHONE_AND_CAMERA_TITLE_TEXT = 'Please install a camera and microphone'
export const PLEASE_ENABLE_MICROPHONE_DESCRIPTION_TEXT =
  'Please enable microphone on your browser. You may need to restart your browser.'
export const PLEASE_ENABLE_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT =
  'Please enable microphone and video on your browser. You may need to restart your browser.'
export const PLEASE_INSTALL_MICROPHONE_DESCRIPTION_TEXT =
  'Please make sure your microphone is installed and functioning properly. You may need to restart your browser'
export const PLEASE_INSTALL_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT =
  'Please make sure your camera and microphone are installed and functioning properly. You may need to restart your browser.'
export const PRESCRIBED_BY_TEXT = 'Prescriber'
export const DISPENTSE_AMOUNT_TEXT = 'Dispense amount'
export const QUANTITY_TEXT = 'Quantity'
export const DIRECTIONS_TEXT = 'Directions'
export const REFILLS_TEXT = 'Refills'
export const PHARMACY_TEXT = 'Pharmacy'
export const NCPDP_ID_TEXT = 'NCPDP ID'
export const PHONE_TEXT = 'Phone'
export const STREET_TEXT = 'Street'
export const CITY_TEXT = 'City'
export const CREATED_TEXT = 'Created'
export const NOTE = 'Note'
export const STATUS_TEXT = 'Status'
export const STATUS_PENDING_TEXT = 'PENDING'
export const STATUS_XMIT_TEXT = 'XMIT'
export const STATUS_XMIT_FAILED_TEXT = 'XMIT_FAILED'
export const STATUS_PRINTED_TEXT = 'PRINTED'
export const STATUS_CANCELED_TEXT = 'CANCELED'
export const STATUS_CANCEL_PENDING_TEXT = 'CANCEL_PENDING'
export const STATUS_CANCEL_DENIED_TEXT = 'CANCEL_DENIED'
export const NO_ALLERGY_ON_CHART_TEXT = 'No allergy on chart'
export const NO_ALLERGY_HAVE_BEEN_ADDED_TEXT = 'No allergies have been added to this patient’s chart.'
export const PREFERRED_NAME_TEXT = 'Preferred name'
export const CLOSE_TEXT = 'Close'
export const PATIENT_CHARTS_TEXT = 'Patient charts'
export const VISIT_NOTE_TEXT = 'Visit note'
export const PATIENT_PAST_VISIT_TEXT = 'Patient past visit'
export const VISIT_TEXT = 'Visit:'
export const VISIBLE_TO_PATIENT_IN_VISIT_SUMMARY_TEXT = 'Visible to patient in visit summary.'
export const TYPE_SOMETHING_TEXT = 'Type something...'
export const NO_PRESCRIPTIONS_TEXT = 'No prescriptions'
export const NO_NOTES_TEXT = 'No notes'
export const NO_PATIENT_INSTRUCTIONS_TEXT = 'No patient instructions'
export const NEW_TEXT = 'New'
export const UNSAVED_CHANGES_TEXT = 'Unsaved changes'
export const SAVE_TEXT = 'Save changes'
export const DISCARD_CHANGES_TEXT = 'Discard changes'
export const UNSAVED_CHANGES_VISIT_NOTES_POPUP_BODY_TEXT =
  'You have unsaved changes made to visit note which will be lost if you navigate away. Would you like to save these changes?'
export const FIRST_NAME_TEXT = 'First name'
export const LAST_NAME_TEXT = 'Last name'
export const STREET_ADDRESS_TEXT = 'Street address'
export const PREFFERED_PHARMACY_TEXT = 'Preferred pharmacy'
export const RELATIONSHIP_TO_PATIENT_TEXT = 'Relationship to patient'
export const PHONE_NUMBER_TEXT = 'Phone number'
export const NO_RESULTS_TEXT = 'No results'
export const NO_FILES_TEXT = 'No files'
export const FILES_TEXT = 'Files'
export const EMERGENCY_CONTACT_TEXT = 'Emergency contact'
export const CLEAR_TEXT = 'Clear'
export const VISIT_FILTER_DROPDOWN_LABEL = 'Service type (Visit type)'
export const STATUS_FILTER_DROPDOWN_LABEL = 'Visit status'
export const HEIGHT_TEXT = 'Height'
export const WEIGHT_TEXT = 'Weight'
export const ON_TEXT = 'on'
export const OFF_TEXT = 'off'
export const SMS_MESSAGING_TEXT = 'SMS messaging'
export const CHOOSE_MESSAGES_TO_RECEIVE_ON_MOBILE_TEXT =
  'Choose the messages you would like to receive on your mobile device.'
export const UPCOMING_SHIFT_TEXT = 'Upcoming shift'
export const PATIENT_JOINED_WAITING_ROOM_TEXT = 'Patient joined waiting room'
export const ENDED_VISITS_REMINDER_TEXT = 'Ended visits reminder'
export const LAST_MINUTE_BOOKING_ALERT_TEXT = 'Last-minute booking alert'
export const EDIT_TEXT = 'Edit'
export const ALLERGY_TEXT = 'Allergy'
export const SEVERITY_TEXT = 'Severity'
export const REMOVE_ALLERGIES_CONFIRMATION =
  "This will remove all existing allergies from the patient's chart. \n Do you wish to continue?"
export const ARE_YOU_SURE = 'Are you sure?'
export const MAT_MOUD_TEXT = 'MAT/MOUD'
export const EMPTY_TEXT_NA = 'N/A'
export const DELETE_TEXT = 'Delete'

export const STATUS_VALUES_MAP = new Map([
  [STATUS_PENDING_TEXT, 'Pending'],
  [STATUS_XMIT_TEXT, 'Sent'],
  [STATUS_XMIT_FAILED_TEXT, 'Failed to send'],
  [STATUS_PRINTED_TEXT, 'Printed'],
  [STATUS_CANCELED_TEXT, 'Canceled'],
  [STATUS_CANCEL_PENDING_TEXT, 'Cancel pending'],
  [STATUS_CANCEL_DENIED_TEXT, 'Cancel denied'],
])

export const FREQUENCY_TEXT = 'Frequency'
export const STATE_TEXT = 'State'
export const ZIP_TEXT = 'ZIP'
export const FOR_TEXT = 'for'
export const DAY_TEXT = 'day'
export const DAYS_ONLY_TEXT = 'days'
export const REASON_FOR_VISIT_FLAG = 'Reason for visit'
export const SAVE_CHANGES_TEXT = 'Save changes'
export const CANCEL_TEXT = 'Cancel'
export const CONFIRM_TEXT = 'Confirm'

// DAYS OF WEEK

export const SUNDAY = 'Sunday'
export const MONDAY = 'Monday'
export const TUESDAY = 'Tuesday'
export const WEDNESDAY = 'Wednesday'
export const THURSDAY = 'Thursday'
export const FRIDAY = 'Friday'
export const SATURDAY = 'Saturday'

export const APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION = 'Visit'
export const APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION = 'Method'
export const APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION = 'Patient address'
export const APPOINTMENT_ADDITIONAL_PATIENT_BOOKING_STATE_OPTION = 'Booking state'
export const APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION = 'Visit status'
export const APPOINTMENT_INFO_ID_CONSTANT_PART = 'appointmentInfo'

export const APPOINTMENT_TYPE_CALL = 'call'
export const APPOINTMENT_TYPE_PHONE = 'Phone'
export const DETAILS_INFO_TYPE_PNB = 'PNB'
export const DETAILS_INFO_TYPE_AVAILABILITY = 'availability'
export const DATE_FORMAT_TYPE_DATE = 'Date'
export const OVERLAP_DATE_FORMAT = 'Date_overlap'
export const DATE_FORMAT_TYPE_TIME = 'Time'
export const APPOINTMENT_VIEW_TYPE_LABEL = 'appointment'

export const APPOINTMENT_INFO_PATIENT_NAME_ROW_ID = 'patientNameRow'
export const PATIENTS_INFO_PREFFERED_NAME_ID = 'patientsInfoPrefferedName'
// Visits sorting
export const VISITS_ALL_SORT_CONDITION = 'All'
export const VISITS_FULL_NAME_SORT_CONDITION = 'Full name'
export const VISITS_EMAIL_SORT_CONDITION = 'Email'
export const VISITS_MRN_SORT_CONDITION = 'MRN'
export const VISITS_ALL_REQUEST_CONDITION = 'all'
export const VISITS_FULL_NAME_REQUEST_CONDITION = 'patientname'
export const VISITS_EMAIL_REQUEST_CONDITION = 'patientemail'
export const VISITS_MRN_REQUEST_CONDITION = 'patientmedicalrecordnumber'
export const visitTableTitles = {
  DATE: 'Date',
  SCHEDULED_ON: 'Scheduled on',
  STATUS: 'Status',
  VISIT: 'Visit',
  PROVIDER: 'Provider',
  PATIENT: 'Patient',
  REMARKS: 'Remarks',
  TAGS: 'Tags',
}

export const VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitPageFilterStatusProvider'
export const VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitPageFilterVisitTypesProvider'

// Charts sorting
export const CHARTS_EMAIL_SORT_CONDITION = 'Email'
export const CHARTS_MRN_SORT_CONDITION = 'MRN'
export const VISIT_NOTE_BLOCK_TITLE = 'Visit note'
export const VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE = 'Note'
export const ALERTS_SECTIONS_EMPTY_TEXT = 'No alerts'
export const VISIT_NOTE_BLOCK_EDITOR_TITLE = 'Note addendum'
export const VISIT_NOTE_BLOCK_TEXT_EDITOR_ID = 'visitCallRoomNoteTextEditor'
export const VISIT_NOTE_BLOCK_TEXT_EDITOR_PLACEHOLDER_TEXT = 'Begin typing here...'
export const PATIENT_INSTRUCTIONS_TITLE_TEXT = 'Patient instructions'
export const PATIENT_INSTRUCTIONS_EDITOR_TITLE_TEXT = 'Patient instructions addendum'
export const PATIENT_INSTRUCTIONS_SUBTITLE_TEXT = 'Visible to patient in visit summary.'
export const VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT = 'Prescriptions'
export const VIDEO_CALL_NOTES_PRESCRIPTIONS_SUBTITLE_TEXT = 'Visible to patient in visit summary.'
export const PATIENT_INSTRUCTIONS_TEXT_EDITOR_ID = 'visitCallRoomPatientInstructionsTextEditor'

export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_TITLE_TEXT = 'Visit in progress'
export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_TITLE_AFTER_END_BTN_TEXT = 'Visit is without final status'
export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_BODY_TEXT =
  'Visit is still in progress. Are you sure you want to leave the visit and send the patient back in queue?'
export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_BODY_AFTER_END_BTN_TEXT =
  ' No final status has been assigned to this visit yet. If you leave the visit now you need to assign final status to this visit later. Are you sure you want to leave?'
export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_PRIMARY_BTN_TEXT = 'Leave'
export const VIDEO_CALL_ROOM_BACK_BTN_CONFIRMATION_POP_UP_SECONDARY_BTN_TEXT = 'Cancel'
export const VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_TITLE = 'Reason for unresolved visit'
export const VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SUBTITLE = 'You must provide a reason for unresolved visit'
export const VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_PRIMARY_BTN_TEXT = 'Save'
export const VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SECONDARY_BTN_TEXT = 'Cancel'
export const OTHER_DROPDOWN_OPTION = 'Other'
export const unresolvedReasonsDropdownOptions = [
  'Technical difficulties (audio and/or video problems)',
  'Patient was a no-show for the appointment - never answered the phone or not seen on video',
  'Patient requesting a medicine not available via QuickMD',
  'Patient with a medical condition not amenable to treatment via telehealth',
  'Patient mismatch - Person on audio or video is not the patient whose chart is associated with the appointment',
  OTHER_DROPDOWN_OPTION,
]

export const visitListStatuses = {
  IN_WAITING_ROOM: 'inwaitingroom',
  IN_WAITING_ROOM_BACK: 'inwaitingroomback',
  IN_PROGRESS: 'inprogress',
  UNRESOLVED: 'unresolved',
  RESOLVED: 'resolved',
  CANCELED_BY_PATIENT: 'cancelledbypatient',
  SCHEDULED_BY_PATIENT: 'scheduledbypatient',
  RESCHEDULED_BY_PATIENT: 'rescheduledbypatient',
  ENDED: 'ended',
  SUCCESSFUL: 'completed',
  CANCELED_BY_STAFF: 'cancelledbyadmin',
  SCHEDULED_BY_ADMIN: 'scheduledbyadmin',
  RESCHEDULED_BY_ADMIN: 'rescheduledbyadmin',
}
export const visitListStatusesEncrypted = {
  IN_WAITING_ROOM: 'In waiting room',
  IN_PROGRESS: 'In progress',
  UNRESOLVED: 'Unresolved',
  RESOLVED: 'Resolved',
  CANCELED_BY_PATIENT: 'Canceled by patient',
  SCHEDULED_BY_PATIENT: 'Patient scheduled',
  RESCHEDULED_BY_PATIENT: 'Patient rescheduled',
  ENDED: 'Ended',
  SUCCESSFUL: 'Complete',
  CANCELED_BY_STAFF: 'Canceled by staff',
  SCHEDULED_BY_ADMIN: 'Staff scheduled',
  RESCHEDULED_BY_ADMIN: 'Staff rescheduled',
}

export const PAST_VISIT_NOTES_SECTION_ADDENDUM_BTN_TITLE = 'Addendum'

export const ICD_CODES_SEARCH_TYPES = [
  { name: 'Broad match', value: 'broadmatch', active: true },
  { name: 'Exact match', value: 'exactmatch', active: false },
]

export const tableViewOptions = ['Upcoming', 'Past']

export const LOCAL_STORAGE_STATE_TO_PAST_VISIT = 'LocalStorageStateToPastVisit'
export const LOCAL_STORAGE_STATE_TO_CALENDAR = 'LocalStorageStateToCalendar'

export const SESSION_ON_STORAGE_KEY = 'sessionOn'

// Waiting room table items statuses

export const WAITING_ROOM_TABLE_ITEMS_STATUSES = {
  IN_PROGRESS: 'inprogress',
  IN_WAITING_ROOM: 'inwaitingroom,',
}

export const QUICK_MD_TITLE_TEXT = 'QuickMD'

export const ABBREVIATION_TO_DAY_OF_WEEK = {
  Sun: 'sunday',
  Mon: 'monday',
  Tue: 'tuesday',
  Wed: 'wednesday',
  Thu: 'thursday',
  Fri: 'friday',
  Sat: 'saturday',
}

export const NAVIGATION_TYPES = {
  NAVIGATE: 'navigate',
  RELOAD: 'reload',
  BACK_FORWARD: 'back_forward',
  RESERVED: 'reserved',
}

export const PAST_VISIT = ['ended', 'unresolved', 'completed', 'resolved', 'cancelledbypatient', 'cancelledbyadmin']
export const UPCOMING_VISIT = [
  'scheduledbypatient',
  'scheduledbyadmin',
  'inwaitingroom',
  'inwaitingroomback',
  'inprogress',
  'rescheduledbypatient',
  'rescheduledbyadmin',
]
export const TIME_ZONE = 'Time zone'
export const DRUG_SCREEN_STATUS = {
  verified: 'verified',
  legacyunverified: 'legacyunverified',
  addressunverified: 'addressunverified',
  expired: 'expired',
  due: 'due',
  duesoon: 'duesoon',
  exempt: 'exempt',
  review: 'review',
}
export const TAGS_FILTER_DROPDOWN_LABEL = 'Tags'
export const VISITS_TAGS_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitTagsFilter'
export const ID_VERIFICATION_STATUSES = {
  warning: 'warning',
  failed: 'failed',
  verified: 'verified',
  processing: 'processing',
  manuallyverified: 'manuallyverified',
  legacyverified: 'legacyverified',
  requested: 'requested',
  unverified: 'unverified',
}
// Popup Titles
export const VISIT_CANCELED_TITLE = 'Visit has been canceled'

// constants.js

export const VISIT_CANCELED_WITH_CHANGES_BODY = `This visit has been canceled and will be moved to Past visits. However, there are unsaved changes to this visit note. Would you like to save these changes?`

export const VISIT_CANCELED_WITH_CHANGES_SUB = `*Please note that you will not be able to make any changes to this note after this point.`

export const VISIT_CANCELED_NO_CHANGES_BODY =
  'This visit has been canceled and will be moved to the Past visits section.'
export const SAVE_AND_CLOSE_TEXT = 'Save and close'
export const CLOSE_WITHOUT_SAVING_TEXT = 'Close without saving'
export const OKAY_TEXT = 'Okay'

export const MAX_DTS_NOTE_LENGTH = 110
